<template>
  <span v-if="hasIdCard">
    <DocumentAnalysisBadge
      :verdict="analysisVerdict"
      :is-analyzed="Boolean(idCardAnalyzedAt)"
      :has-error="analysisHasError"
      :tooltip="analysisBadgeLabel"
      :clickable="canOpenAnalysisModal"
      @click="analysisModalOpen = true"
    />
    <IdCardAnalysisModal
      :open="analysisModalOpen"
      :analysis="idCardAnalysis"
      :analyzed-at="idCardAnalyzedAt"
      :analysable-id="declaration.id"
      analysable-type="Claims::Declaration"
      :claim-active="claimActive"
      @close="analysisModalOpen = false"
      @retry-success="$emit('retry-success')"
    />
  </span>
</template>

<script>
import { useI18n } from "vue-i18n";
import DocumentAnalysisBadge from "@/components/claim/details/DocumentAnalysisBadge.vue";
import IdCardAnalysisModal from "@/components/claim/details/IdCardAnalysisModal.vue";
import { verdictLabel } from "@/components/claim/details/idCardAnalysisFormatter";

export default {
  components: {
    DocumentAnalysisBadge,
    IdCardAnalysisModal,
  },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  emits: ["retry-success"],
  props: {
    declaration: {
      type: Object,
      default: null,
    },
    claimActive: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      analysisModalOpen: false,
    };
  },

  computed: {
    hasIdCard() {
      return (this.declaration?.idCard?.length || 0) > 0;
    },
    idCardAnalysis() {
      return this.declaration?.idCardAnalysis || null;
    },
    idCardAnalyzedAt() {
      return this.declaration?.idCardAnalyzedAt || null;
    },
    analysisVerdict() {
      return this.declaration?.idCardAnalysisVerdict || null;
    },
    analysisHasError() {
      return Boolean(this.idCardAnalysis?.error);
    },
    canOpenAnalysisModal() {
      return Boolean(this.idCardAnalyzedAt) || this.analysisHasError;
    },
    analysisBadgeLabel() {
      if (this.analysisHasError) return this.t("unavailable");
      if (!this.idCardAnalyzedAt) return this.t("not_analyzed");
      return verdictLabel(this.t, this.analysisVerdict);
    },
  },
};
</script>

<i18n src="./IdCardAnalysisBadge.i18n.json"></i18n>
